import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '@/hooks/useUser';
import { usePermissions, type ModuleKey } from '@/hooks/usePermissions';

interface ProtectedRouteProps {
  children: React.ReactNode;
  module: ModuleKey;
}

export function ProtectedRoute({ children, module }: ProtectedRouteProps): JSX.Element {
  const location = useLocation();
  const { user, loading: userLoading, metadata } = useUser();
  const { canAccess, loading: permLoading } = usePermissions();

  if (userLoading || permLoading) {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-muted-foreground">
        Chargement…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (!metadata) {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-muted-foreground">
        Profil introuvable. Contactez votre administrateur.
      </div>
    );
  }

  if (!canAccess(module)) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
}
